var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{attrs:{"id":"section_loader"}},[_c('vs-button',{attrs:{"color":"primary","type":"filled","icon":"attachment"}},[_vm._v("\n    Cargar archivo\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }